<button
  type="button"
  class="btn btn-link btn-link-action pdp-alignment-fix"
  (click)="modalDialog.show()"
  aria-haspopup="dialog"
>
  {{ linkText() | translate }}
</button>
<ish-modal-dialog #modalDialog [options]="options()" (shown)="shown()" (closed)="closed()">
  @if (lazyContent()) { @if (shown$ | async) {
  <div>
    <ng-container *ngTemplateOutlet="lazyContent().templateRef" />
  </div>
  } } @else {
  <ng-content />
  }
</ish-modal-dialog>
